var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.mortgageLayout ? _c('div', [_vm.brokerId ? _c('div', {
    staticClass: "hypotekacta hypoteka pointer"
  }, [_vm.imageLoaded ? _c('div', [_c('span', {
    staticClass: "blc-color"
  }, [_vm._v(" " + _vm._s(_vm.broker.first_name) + " " + _vm._s(_vm.broker.last_name) + " ")])]) : _vm._e()]) : _c('div', {
    staticClass: "hypotekacta w-inline-block pointer",
    staticStyle: {
      "margin-left": "6px"
    },
    on: {
      "click": function click($event) {
        return _vm.openBrokerAssignPicker();
      }
    }
  }, [_c('img', {
    staticClass: "nav-link-icon filter-primary",
    attrs: {
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f1d_icons8-add.svg"
    }
  }), _c('span', {
    staticClass: "bl-color noselect pop-600",
    staticStyle: {
      "padding-left": "25px"
    }
  }, [_vm._v("pridať brokera")])])]) : _vm._e(), _vm.klient ? _c('div', [_vm.brokerId ? _c('div', {
    staticClass: "klienticta pointer w-inline-block"
  }, [_vm.imageLoaded ? _c('div', {
    staticClass: "broker-avatar-trigger",
    attrs: {
      "title": _vm.brokerDisplayName ? "Pridelen\xFD finan\u010Dn\xEDk: ".concat(_vm.brokerDisplayName) : 'Zmeniť prideleného finančníka'
    },
    on: {
      "click": function click($event) {
        return _vm.openBrokerAssignPicker();
      }
    }
  }, [_c('img', {
    staticClass: "broker-image",
    attrs: {
      "src": _vm.image,
      "loading": "lazy",
      "height": "20",
      "width": "20",
      "alt": _vm.brokerDisplayName ? "Pridelen\xFD finan\u010Dn\xEDk ".concat(_vm.brokerDisplayName) : 'Pridelený finančník'
    }
  })]) : _vm._e()]) : _c('div', {
    staticClass: "klienticta w-inline-block pointer",
    on: {
      "click": function click($event) {
        return _vm.openBrokerAssignPicker();
      }
    }
  }, [_c('img', {
    staticClass: "nav-link-icon filter-primary",
    attrs: {
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f1d_icons8-add.svg"
    }
  })])]) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }